import {LifeOrderList} from "./LifeOrderList";
import {LifeOrderEdit} from "./LifeOrderEdit";
import {LifeOrderCreate} from "./LifeOrderCreate";

export default {
    list: LifeOrderList,
    create: LifeOrderCreate,
    edit: LifeOrderEdit
};
